import { render, staticRenderFns } from "./ModernShell.vue?vue&type=template&id=849ad89e&"
import script from "./ModernShell.vue?vue&type=script&lang=js&"
export * from "./ModernShell.vue?vue&type=script&lang=js&"
import style0 from "./ModernShell.vue?vue&type=style&index=0&id=849ad89e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports